import { Link } from 'react-router-dom';
import { EVENT, PRIME_DAY_PATH, isPromoted } from '../../utils/primeDay';
import './PrimeDayPage.css';

/**
 * One-line homepage banner linking to the Prime Day page. The server pre-renders
 * the same markup (primeBanner in lib/prerender.js) so it doesn't push the page
 * down when React starts.
 */
const PrimeDayBanner = () => {
  if (!isPromoted()) return null;
  return (
    <Link className="prime-day-banner" to={PRIME_DAY_PATH}>
      <strong>{EVENT.name}</strong>
      {` · ${EVENT.datesLabel}: see the deals worth buying →`}
    </Link>
  );
};

export default PrimeDayBanner;
